// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"98":"2f5a44a14f1b66a0","167":"f05d9f020b064bab","349":"250be95b5bd08ade","410":"e3fc1ad17434c05e","467":"8ea66b3348a975ec","568":"439fcd3d3a7ac332","643":"ed837ee241a78e0d","736":"54cee5f44521af5f","819":"6db265c57f84c0ba","861":"408cabbb21fabcad"}[chunkId] + ".js";
};